import { render, staticRenderFns } from "./api.vue?vue&type=template&id=35e8bcfe"
import script from "./api.vue?vue&type=script&lang=js"
export * from "./api.vue?vue&type=script&lang=js"
import style0 from "./api.vue?vue&type=style&index=0&id=35e8bcfe&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports